import {Lang} from 'yougile-lang'
import {logger, UIUtil} from 'yougile-util'
import {ClientUtilities} from '@client/client-utilities'
import {MessageBox} from '@components/message-box'

const slashReg = /\/|\\/gi

// const templateFile = new File([], '', {
//   type: 'image/jpeg'
// })

export const downloadImageByUrl = async (
  url: string,
  name: string
): Promise<string | undefined> => {
  // TODO revert progress bar, when revert good quality images
  // const id = Util.UUID()
  // FileUploadProgress.addFile(id, templateFile)

  const file = await getFileByUrl(url, name)
  if (!file) {
    return undefined
  }

  if (!UIUtil.isSupportedImage(file)) {
    MessageBox.warn(Lang.msg.imageTypeUnsupported)
    return undefined
  }

  try {
    // FileUploadProgress.changeFile(id, file)
    const savedFile = await ClientUtilities.saveFile(
      {file},
      undefined,
      // (p: number) => FileUploadProgress.updateProgress(id, p)
      undefined,
      {mimeType: 'image/jpeg', quality: 0.3, raw: false}
    )
    // FileUploadProgress.removeFile(id)
    return savedFile
  } catch (e) {
    logger.error('Cannot save image', e)
    // FileUploadProgress.removeFile(id)
    return undefined
  }
}

export const getFileByUrl = async (
  url: string,
  name: string
): Promise<File | undefined> => {
  if (!url) {
    return undefined
  }

  const fileName = processFileName(name)
  try {
    const respond = await fetch(url)
    const readableStream = respond.body

    if (!readableStream) {
      logger.error('Cannot get image, readableStream is empty')
      return undefined
    }

    const resp = new Response(readableStream)
    const data = await resp.blob()

    return new File([data], fileName, {
      type: respond?.headers?.get('content-type') || 'image/jpeg'
    })
  } catch (e) {
    logger.error('Cannot get image', e)
    return undefined
  }
}

const processFileName = (name: string): string => {
  if (slashReg.test(name)) {
    name = name.replace(slashReg, '__')
  }

  return `${name}.jpeg`
}
